export default __webpack_public_path__ + "twitch-sqr-v1.svg";